import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import {enumerate} from 'ts-transformer-enumerate';

import {__} from '~/shared/src/utilities/messageCatalog';
import metaModel from '~/shared/src/utilities/metaModel';

import {Panel} from 'primereact/panel';

import ContentButton, {ReferenceType as ContentButtonType} from '~/frontend/src/components/base/shared/ContentButton';
import SearchField from '~/frontend/src/components/base/shared/field/SearchField';

import {FinderOverviewPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/definitions';

import {StoreState} from '~/frontend/src/store';
import openPanel from '~/frontend/src/actions/panelManager/openPanel';


type Props = {

    /**
     * The CSS class name(s) to add to the component.
     */
    className? : string;
};

type AllProps = Props;


const getMobile = () => matchMedia( 'screen and (max-width: 960px)' ).matches ? true : false;
const schemata = enumerate<YnSchema>();

/**
 * quicksearch field
 * @return {JSX.Element}
 * @constructor
 */
const QuickSearchField = ( props : AllProps ) => {
    const {
              className
          }                     = props,
          dispatch              = useDispatch(),
          user                  = useSelector( ( state : StoreState ) => state.session?.user ? state.session.user : undefined ),
          button                = useRef<ContentButtonType>( null ),
          [ mobile, setMobile ] = useState<boolean>( getMobile() ),
          [ value, setValue ]   = useState( '' ),
          hasSchemaPermission   = useMemo(
              () => {
                  let retVal : boolean = false;

                  for ( const schema of schemata ) {
                      const itemTypes = metaModel[ schema ].getItemTypes() ?? [];

                      for ( const itemType of itemTypes ) {
                          if (
                              itemType.id > 0
                              && user?.hasGenericPermissionOnItemType( 'read', itemType.id, schema )
                          ) {
                              retVal = true;
                              break;
                          }
                      }
                  }

                  return retVal;
              },
              [
                  schemata,
                  user
              ]
          ),
          onChange              = useCallback(
              ( searchString : string ) => {
                  setValue( searchString );
              },
              [
                  'onlyOnce'
              ]
          ),
          onClear               = useCallback(
              () => {
                  setValue( '' );
              },
              [
                  'onlyOnce'
              ]
          ),
          onSearch              = useCallback(
              () => {
                  const panelParams : FinderOverviewPanelProps = {
                      panelType: 'FinderOverview',
                      title    : 'YN.base.common.QuickSearch',
                      iconCls  : 'pi pi-search',
                      //
                      schema   : global.schema,
                      status   : 'active',
                      timestamp: 'now',
                      //
                      searchString: value,
                      search      : true
                  };

                  if ( config.sysGroups?.admin && user && user.isMemberOfGroup( config.sysGroups.admin ) && value.match( '^(cfg|CFG|data|DATA):' ) ) {
                      panelParams.schema = value.match( '^(cfg|CFG|data|DATA)(:.*)$' )?.[ 1 ]?.toUpperCase() as Schema;
                      panelParams.searchString = value.substring( panelParams.schema.length + 1 );
                  }

                  button.current?.collapse( new MouseEvent( 'click' ) as unknown as React.MouseEvent );
                  dispatch( openPanel( panelParams ) );
              },
              [
                  user,
                  value
              ]
          ),
          content               = useMemo(
              () => {
                  let retVal = <></>;

                  if ( user ) {
                      retVal = <SearchField
                          uid="pageQuickSearch"

                          value={value}

                          onSearch={onSearch}
                          onClear={onClear}
                          onChange={onChange}

                          placeholder={__( 'YN.base.common.QuickSearch' )}
                          className={`yn-page-quicksearch ${className}`}
                          style={{ display: hasSchemaPermission ? 'inline-block' : 'none', width: '20rem', marginBottom: '0' }}
                      />;

                      if ( mobile ) {

                          // TODO: implement
                          //  ContentButton -> implement verticalContentAlign 'center'
                          //  content={retVal}

                          return <ContentButton
                              id="page-menu-quicksearch-button"
                              ref={button}

                              horizontalContentAlign="left"
                              verticalContentAlign="bottom"
                              rounded={true}
                              text={true}
                              icon={'pi pi-search'}
                              className="yn-quicksearch-button"
                              style={{ display: hasSchemaPermission ? 'inline-block' : 'none' }}
                              buttonClassName="yn-quicksearch-button"
                              contentClassName="yn-contentbutton-overlay-content-page-menu"

                              content={
                                  <Panel
                                      style={{ width: '21rem' }}
                                      pt={{
                                          content: {
                                              style: {
                                                  border : 'none',
                                                  padding: '.5rem'
                                              }
                                          }
                                      }}
                                  >
                                      {retVal}
                                  </Panel>
                              }
                          />;
                      }
                  }

                  return retVal;
              },
              [
                  className,
                  mobile,
                  user,
                  value
              ]
          );


    // add/remove listener for color scheme switch ( on mount only -> [] )
    useEffect(
        () => {
            const matchWidthChangeHandler = () => {
                setMobile( getMobile() );
            };

            matchMedia( 'screen and (max-width: 960px)' ).addEventListener( 'change', matchWidthChangeHandler );
            return () => {
                matchMedia( 'screen and (max-width: 960px)' ).removeEventListener( 'change', matchWidthChangeHandler );
            }
        },
        []
    );

    return content;
}

export default QuickSearchField;
